module.exports = __webpack_public_path__ + "static/media/sort.9166e56a.svg";